import React, { FC, PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';
import { ProductsTypeEnum } from '@guest-widgets/shared/src/types/product/baseProduct';

import { config } from '../../config';

import { QueryLink } from './QueryLink';

const { productIdQueryKey, productTypeQueryKey } = config;

interface ProductLinkProps {
  id: string;
  productType?: string;
  onClick?: () => void;
}

export const ProductLink: FC<PropsWithChildren<ProductLinkProps>> = ({
  id,
  productType,
  children,
  onClick,
}) => {
  const query: Record<string, string> = {
    [productIdQueryKey]: id,
    rwstep: 'product',
  };

  if (productType === ProductsTypeEnum.GIFTCARD) {
    query[productTypeQueryKey] = productType;
  }

  return (
    <StyledQueryLink query={query} onClick={onClick}>
      {children}
    </StyledQueryLink>
  );
};

const StyledQueryLink = styled(QueryLink)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  display: 'block',
  height: '100%',
  textDecoration: 'none',
  transition: theme.transitions.create(['transform', 'box-shadow'], {
    duration: theme.transitions.duration.shorter,
  }),
  '&:hover, &:focus': {
    transform: 'scale(1.012)',
    boxShadow: '0 0 24px 0 rgba(0, 0, 0, 0.1)',
  },
  '&:active': {
    transform: 'scale(1.006)',
    boxShadow: '0 0 12px 0 rgba(0, 0, 0, 0.1)',
  },
}));
